import type { RejectionDetails } from '../../utility/shared'

/**
 * Rejection applied to items cancelled on the original
 * order by the core-to-tpos splitting step.
 */
export const splitOrderRejectionDetails: RejectionDetails = {
  reason: 'Split to another order',
  reasonCode: 'SPLIT_TO_ANOTHER_ORDER',
}
